import { Component, EventEmitter, Inject, Input, OnInit, OnDestroy, Output } from '@angular/core';

import { RidePlannerFacade } from '@ridango/components';
import { ProductsSelectorFacade } from '@ridango/components/lib/products-selector/+state/products-selector.facade';
import { AppStartupService, Product, BaseComponent } from '@ridango/core';

import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Env from '@ridango/core/env';

@Component({
    selector: 'rwidget-booking-summary',
    templateUrl: './booking-summary.component.html',
    styleUrls: ['./booking-summary.component.scss']
})
export class BookingSummaryComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() isValidated = false;
    @Input() loading = false;
    @Input() products: Product[] = [];
    @Output() onSubmitBookings = new EventEmitter();

    estimatedPrice$: Observable<number> = this.ridePlanner.estimatedPrice$;
    infinity = Infinity;
    productId: string;
    passengerCount = 0;

    stops: any = [];
    coordinates: any;
    dateTime: any;

    constructor(
        @Inject('ENV') public env: Env,
        private ridePlanner: RidePlannerFacade,
        public appStartupService: AppStartupService,
        public productsSelector: ProductsSelectorFacade
    ) {
        super();
    }

    ngOnInit() {
        this.ridePlanner.stops$.pipe(takeUntil(this.componentDestroyed$)).subscribe((stops) => (this.stops = stops));

        this.coordinates = this.stops.map(({ latitude, longitude }) => ({ latitude, longitude }));

        this.ridePlanner.dateAndTime$
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((dateTime) => (this.dateTime = dateTime));

        if (!this.products.length) {
            this.ridePlanner.fetchEstimatedPrice(this.dateTime, this.coordinates);
        }
    }

    submitBooking() {
        this.ridePlanner.setProductId(this.productId);
        this.onSubmitBookings.emit();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
